
import Routes from './routes';
import PullToRefresh from '~/components/atoms/PullToRefresh';
import useRefreshFeatureFlags from '~/hooks/useRefreshFeatureFlags';

export default function App() {
  useRefreshFeatureFlags();
  return (
    <>
      <PullToRefresh />
      <Routes />
    </>
  );
}
